// @ts-nocheck
import { Icon, Tooltip } from '@aloft/toolkit-sui';
import { IconButton, Th } from '@aloft/toolkit-sui/chakra';

import { useWatch } from 'react-hook-form';

import { ValuationTablePropertyHeader } from '../../../../components/ValuationTablePropertyHeader/ValuationTablePropertyHeader.js';
import { useZodFormContext } from '../../../../hooks/useZodForm.js';
import { schPrice } from '../../schemas.js';
import { PairedSalesFormSchema } from '../../types.js';

export const PairGridHeader = ({
  pairIndex,
  property,
  onSwapProperties,
}: {
  pairIndex: number;
  property: 'p1' | 'p2';
  onSwapProperties: () => void;
}) => {
  const { control } = useZodFormContext<PairedSalesFormSchema>();

  const p = useWatch({ name: `selectedPairs.${pairIndex}.${property}`, control });

  const salePrice = schPrice.safeParse(p?.salePrice);

  return (
    <Th key={p?.toolkitRecordID} padding="0px !important" colSpan={2}>
      <ValuationTablePropertyHeader
        title={p?.address?.AddressLineText ?? 'Unknown Address'}
        subtitle={`${p?.address?.CityName}, ${p?.address?.StateCode} ${p?.address?.PostalCode}`}
        statPrimary={`SP: ${salePrice.success ? salePrice.data?.toString(true) : 'Error'}`}
        photoUrl={p?.images?.[0]?.url}
        latitude={p?.latitude}
        longitude={p?.longitude}
        zIndex={1}
        {...(property === 'p2' && {
          primaryActionButton: (
            <Tooltip label="Swap property order">
              <IconButton
                icon={<Icon icon="arrow-left-right" size="lg" />}
                aria-label="swap property order"
                onClick={onSwapProperties}
                variant="ghost"
                size="sm"
              />
            </Tooltip>
          ),
        })}
      />
    </Th>
  );
};
